import { Lob } from "./lob-enum";

export class LOB {

    private _lob: Number = 0;

    setId(lobId: Number): LOB {
        this._lob = lobId;
        
        return this;
    }

    get lob(): Lob {

        switch (this._lob) {
            case 3:
            case 8:
                return Lob.CarInsurance;
            case 7:
                return Lob.LifeInsurance;
            case 9:
                return Lob.HomeInsurance;
            case 10:
                return Lob.TravelInsurance;
            default:
                return null;
        }

    }

}